module.exports = __webpack_public_path__ + "static/media/partner-logo-4.49b71b58.jpg";